
















import Vue, { PropType } from 'vue';
// import { BrandData } from '@/modules/exhibitor/brand';
// import { Exhibitor } from '@/modules/exhibitor/exhibitor';
// import { FirebaseID } from '@/modules/firestore';

import {
  Exhibitor,
  FirebaseID,
} from 'mostra';

interface StaffOption {
  value: FirebaseID | null;
  text: string;
}

// interface DataType {
//   staffOptions: StaffOption[];
// }

export default Vue.extend({
  name: 'GSelectFormStaff',
  props: {
    value: { type: String as PropType<string>, default: null },
    exclamation: { type: Array as PropType<string[]>, default: () => [] },
    exhibitors: { type: Array as PropType<Exhibitor[]>, default: () => [] },
    // brand: { type: Object as PropType<BrandData>, default: null },
    rules: { type: [String, Object] as PropType<string | object>, default: '' },
  },
  // data(): DataType {
  //   return {
  //     staffOptions: [],
  //   };
  // },
  computed: {
    staffOptions(): StaffOption[] {
      const ls = [];
      // for (let i = 0; i < this.exhibitors.length; i++) {
      for (const e of this.exhibitors) {
        ls.push({
          value: e.id,
          text: e.data.name,
        });
      }
      return ls;
    },
    innerValue: {
      get(): string {
        return this.value;
      },
      set(val: string): void {
        this.$emit('input', val);
      },
    },
  },
  // mounted() {
  //   // todo: 「アカウント/管理メンバー」が未実装なため、仮データから配列を作成。
  //   // todo: 「アカウント/管理メンバー」実装後にここを変更する必要がある可能性はあり。
  //   if (this.exhibitors.length > 0) {
  //     this.staffOptions = [];
  //     for (let i = 0; i < this.exhibitors.length; i++) {
  //       this.staffOptions.push({
  //         value: this.exhibitors[i].id,
  //         text: this.exhibitors[i].data.name,
  //       });
  //     }
  //   }
  // },
});
